import { Form, Formik } from "formik";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../context/ToastProvider";
import useRecoveryRequest from "../../store/Mutations/useRecoveryRequest ";
import InputField from "../InputField/InputField";
import Button from "../Button/Button";
import { ResetPasswordSchema } from "../../scemas/validations";

const ResetPasswordForm = ({
  setShowCheckEmail,
}: {
  setShowCheckEmail?: (value: boolean) => void;
}) => {
  const navigate = useNavigate();
  const { addToast } = useToast();

  const { mutate: sendRecoveryRequest, isPending } = useRecoveryRequest({
    onSuccess: (data, variables) => {
      if (setShowCheckEmail) {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set("email", variables.email);
        const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
        window.history.replaceState(null, "", newUrl);
        setTimeout(() => {
          setShowCheckEmail(true);
        }, 500);
      } else {
        navigate(`/check-email?email=${encodeURIComponent(variables.email)}`);
      }
    },
    onError: (error) => {
      addToast({
        message:
          error.response?.data?.message ||
          "Something went wrong. Please try again.",
        headerText: "Error",
        type: "error",
      });
    },
  });

  return (
    <Formik
      initialValues={{ email: "" }}
      validationSchema={ResetPasswordSchema}
      validateOnBlur={true}
      validateOnChange={true}
      onSubmit={(values) => {
        sendRecoveryRequest({
          email: values.email,
          source: "web",
        });
      }}
    >
      {({ values, setFieldValue, handleBlur, touched, errors }) => (
        <Form
          className={`flex flex-1 flex-col justify-between gap-72 mt-16 ${
            setShowCheckEmail ? "" : "lg:mt-72"
          } max-lg:pb-24`}
        >
          <InputField
            label={"Your email address"}
            required
            placeholder={"Your email address"}
            type="email"
            id="resetPassword-email"
            value={values.email}
            onChange={(e) => setFieldValue("email", e.target.value)}
            onBlur={handleBlur("email")}
            error={touched.email && errors.email ? errors.email : ""}
          />

          <Button
            buttonType="primary"
            type="submit"
            testID="send-instructions"
            title={"Send instructions"}
            loading={isPending}
            className="max-w-450 mx-auto"
          />
        </Form>
      )}
    </Formik>
  );
};

export default ResetPasswordForm;
